import * as React from 'react';
import get from 'lodash/get';
import { FLOW_METRICS_DISPLAY } from '@utils/flow/meta';
import MetricTrend from './MetricTrend';
import * as Styled from '../styled';
import type { AppFlowMetadata } from '@src/hooks/flow/useFlowConfigs';
import type { FlowTimeseriesDataResponse } from '../hooks';
import { getFlowType } from '../utils';

export interface FlowPerformanceProps {
  flowMeta: AppFlowMetadata;
  data: FlowTimeseriesDataResponse;
  onMetricClick: (metricKey: string) => void;
}

const FlowPerformance = ({ flowMeta, data, onMetricClick }: FlowPerformanceProps) => {
  const { metrics } = flowMeta;
  const handleMetricClick = React.useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      const { metricKey } = (e.currentTarget as HTMLDivElement).dataset;

      if (metricKey) {
        onMetricClick(metricKey);
      }
    },
    [onMetricClick],
  );

  return (
    <Styled.FlowSection $direction="row">
      <Styled.VerticalMetricContainer
        $notAvailable={!metrics.network_request_avg_duration}
        data-metric-key={metrics.network_request_avg_duration}
        onClick={handleMetricClick}
      >
        <MetricTrend
          metricKey={metrics.network_request_avg_duration}
          name={FLOW_METRICS_DISPLAY.network_request_avg_duration.shortName}
          description={FLOW_METRICS_DISPLAY.network_request_avg_duration.description}
          data={
            metrics.network_request_avg_duration &&
            get(data, ['data', metrics.network_request_avg_duration], [])
          }
          total={
            metrics.network_request_avg_duration &&
            get(data, ['totals', metrics.network_request_avg_duration], null)
          }
          placeholder={
            <Styled.MetricPlaceholder>
              <Styled.LinkButton
                href={`/app/activation/workflow/${getFlowType(flowMeta)}/${flowMeta.id}?action=network_request`}
                target="_blank"
              >
                + Configure Network Request
              </Styled.LinkButton>
            </Styled.MetricPlaceholder>
          }
        />
      </Styled.VerticalMetricContainer>
      <Styled.VerticalMetricContainer
        $notAvailable={!metrics.network_request_failure}
        data-metric-key={metrics.network_request_failure}
        onClick={handleMetricClick}
      >
        <MetricTrend
          metricKey={metrics.network_request_failure}
          name={FLOW_METRICS_DISPLAY.network_request_failure.shortName}
          description={FLOW_METRICS_DISPLAY.network_request_failure.description}
          data={
            metrics.network_request_failure &&
            get(data, ['data', metrics.network_request_failure], [])
          }
          total={
            metrics.network_request_failure &&
            get(data, ['totals', metrics.network_request_failure], null)
          }
        />
      </Styled.VerticalMetricContainer>
    </Styled.FlowSection>
  );
};

export default React.memo(FlowPerformance);
